import * as React from 'react';

import { modalDriverFactory } from './Modal.driver';
import { Modal } from './index';
import { MODAL_DATA_HOOKS } from './dataHooks';
import { createRendererWithUniDriver } from '../../../test/utils';

describe('Modal', () => {
  const createDriver = createRendererWithUniDriver(modalDriverFactory);
  const children = <div>Children</div>;

  it('should render', async () => {
    const { driver } = createDriver(<Modal isOpen focusTrap={false} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render children', async () => {
    const { driver } = createDriver(
      <Modal isOpen focusTrap={false} children={children} />,
    );

    expect(
      await driver.childExists(`[data-hook="${MODAL_DATA_HOOKS.CONTENT}"]`),
    ).toBe(true);
  });

  it('should render children with appendToBody prop', async () => {
    const { driver } = createDriver(
      <Modal isOpen focusTrap={false} appendToBody children={children} />,
    );

    expect(
      await driver.childExists(`[data-hook="${MODAL_DATA_HOOKS.CONTENT}"]`),
    ).toBe(true);
  });
});
